// Mobile app side track (D16, split per step in F135).
//
// This file is the BARREL. Every app rail step has its own page in its own
// file under `app-track/`, because that is the unit Pavel gives feedback on:
//
//   app / app:apple      -> AppleStep         (rail step 3, "První kroky k aplikaci")
//   app:questionnaire    -> QuestionnaireStep (the ten step wizard)
//   app:release          -> ReleaseStep       (build + both store reviews)
//
// Before F135 one component rendered all three and gated blocks with flags,
// so the Apple step's screen carried the questionnaire card AND the release
// checklist - Pavel, 2026-08-11: "v tom kroku číslo tři, první kroky k
// aplikaci, by vůbec nic nemělo být o dotazníku".
//
// `app` (no step) stays a valid deep link target and lands on the FIRST app
// step, which is the Apple account.
import { AppleStep } from "./app-track/AppleStep";
import { QuestionnaireStep } from "./app-track/QuestionnaireStep";
import { ReleaseStep } from "./app-track/ReleaseStep";
import type { AppTrackProps } from "./app-track/app-track-shared";
import "./app-track/app-track.css";

export { type AppTrackProps } from "./app-track/app-track-shared";
export { AppleStep } from "./app-track/AppleStep";
export { QuestionnaireStep } from "./app-track/QuestionnaireStep";
export { ReleaseStep } from "./app-track/ReleaseStep";

export function AppTrack(props: AppTrackProps) {
  if (!props.includesApp) return null;
  if (props.surface === "app:questionnaire") return <QuestionnaireStep {...props} />;
  if (props.surface === "app:release") return <ReleaseStep {...props} />;
  return <AppleStep {...props} />;
}
